import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SubClan } from './models/clan-interfaces'; // Assume we need the SubClan interface
import { DataSharingService } from './shared/data-sharing.service';
import { switchMap } from 'rxjs/operators';
import { PermissionsModel } from './models/clan-interfaces'; // Assume we need the PermissionsModel interface
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClanService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient, private dataSharingService: DataSharingService) {}

  // Method to fetch permitted clans using the active user account
  fetchPermittedClans(target_Account_Id: string): Observable<SubClan[]> {
    return this.dataSharingService.getActiveUserAccount().pipe(
      switchMap((userAccount) => {
        const owner_id = userAccount.id;
        const authToken = userAccount.authentication;
  
        // Get the friend_Account_id
        const friend_Account_id = target_Account_Id;
        const is_friend_Clans = true;
        // Define headers
        const headers = {
          Authorization: `Bearer ${authToken}`, // Send the authToken in the Authorization header
        };
  
        // Construct the body for the POST request, including friend_Account_id
        const body = { 
          owner_id, 
          friend_Account_id, // Add the friend account id to the body
          is_friend_Clans
        };
  
        // Make POST request to the API with headers and body, return the Observable
        return this.http.post<SubClan[]>(`${this.baseUrl}/fetchPermittedClans`, body, { headers });
      })
    );
  }
  
  

    // Method to update person permission
    updateClanPermission(permissionData: PermissionsModel): Observable<any> {
      return this.dataSharingService.getActiveUserAccount().pipe(
        switchMap((userAccount) => {
          const authToken = userAccount.authentication;
  
          const headers ={
            Authorization: `Bearer ${authToken}`,
          };
  
          return this.http.post<any>(`${this.baseUrl}/updateClanPermission`, permissionData, { headers });
        })
      );
    }
}
